import React from "react";
import { useTheme } from "styled-components";

import { Icon, style } from "./Symbolicons";

const WarningCircle = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M15.999 21.333a.333.333 0 1 0 .003.667.333.333 0 0 0-.003-.667"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="m9.885 27.219-5.104-5.104c-.5-.5-.781-1.179-.781-1.886v-8.458c0-.707.281-1.386.781-1.886l5.104-5.104c.5-.5 1.179-.781 1.886-.781h8.457c.707 0 1.385.281 1.885.781l5.104 5.104c.502.5.783 1.179.783 1.886v8.457c0 .707-.281 1.385-.781 1.885L21.333 28h-9.562a2.667 2.667 0 0 1-1.886-.781v0Z"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16.667V10"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { WarningCircle };
